<ng-container [ngSwitch]="state">
  <!-- Cargando: la silueta de las tarjetas de la pestaña (2 columnas, 1 bajo 992 px). -->
  <div *ngSwitchCase="'loading'" class="snapshot-skeleton" role="status" aria-busy="true" aria-label="Cargando la sección">
    <div class="skeleton-card" *ngFor="let card of [1, 2, 3, 4]">
      <p-skeleton width="45%" height="1.1rem" styleClass="mb-3"></p-skeleton>
      <p-skeleton width="100%" height="0.8rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="85%" height="0.8rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="60%" height="0.8rem"></p-skeleton>
    </div>
  </div>

  <div *ngSwitchCase="'empty'" class="snapshot-state snapshot-state--neutral" [class.snapshot-state--compact]="compact">
    <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
    <span>{{ texts.empty }}</span>
  </div>

  <div *ngSwitchCase="'load-error'" class="snapshot-state snapshot-state--error" [class.snapshot-state--compact]="compact" role="alert">
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <span>No pudimos cargar esta sección.</span>
    <p-button
      data-test="snapshot-retry"
      label="Reintentar"
      icon="fa-solid fa-arrows-rotate"
      styleClass="p-button-sm p-button-outlined"
      (onClick)="onRetry()"
    ></p-button>
  </div>

  <div *ngSwitchCase="'pending'" class="snapshot-state snapshot-state--pending" [class.snapshot-state--compact]="compact">
    <i [ngClass]="issue.pending.icon" aria-hidden="true"></i>
    <div class="snapshot-state__body">
      <span>{{ texts.pending }}</span>
      <small *ngIf="closesAt">Cierre de la ventana: {{ closesAt | mxDate: 'datetime' }}</small>
    </div>
  </div>

  <div *ngSwitchCase="'unavailable'" class="snapshot-state snapshot-state--neutral" [class.snapshot-state--compact]="compact">
    <i class="fa-solid fa-circle-minus" aria-hidden="true"></i>
    <div class="snapshot-state__body">
      <span>{{ texts.unavailable }}</span>
      <small *ngIf="reason === 'NO_SYNTAGE_ENTITY'" data-test="snapshot-reason">Motivo: el cliente no está registrado en Syntage.</small>
    </div>
  </div>

  <div *ngSwitchCase="'not-requested'" class="snapshot-state snapshot-state--neutral" [class.snapshot-state--compact]="compact">
    <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
    <span>{{ texts['not-requested'] }}</span>
  </div>

  <div *ngSwitchCase="'source-error'" class="snapshot-state snapshot-state--error" [class.snapshot-state--compact]="compact">
    <i [ngClass]="issue.error.icon" aria-hidden="true"></i>
    <div class="snapshot-state__body">
      <span>{{ texts['source-error'] }}</span>
      <small *ngIf="retriesAutomatically" data-test="snapshot-retry-note"
        >Syntage no respondió. El sistema hace varios reintentos automáticos en las horas siguientes al análisis; si sigue igual, corre un
        análisis nuevo.</small
      >
    </div>
  </div>

  <div *ngSwitchCase="'reconstructed'" class="snapshot-banner snapshot-banner--provisional" role="note">
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <span
      >Foto armada el {{ builtAt | mxDate }} con los datos que Syntage tenía ese día; no es la del momento del análisis ({{
        analyzedAt | mxDate
      }}).</span
    >
  </div>

  <div *ngSwitchCase="'pre-snapshot'" class="snapshot-state snapshot-state--neutral" [class.snapshot-state--compact]="compact">
    <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
    <span *ngIf="!savedRatios">Este análisis es anterior a la foto de Syntage. Lo que se ve en Análisis es lo que se guardó entonces.</span>
    <span *ngIf="savedRatios" data-test="pre-snapshot-saved-ratios"
      >Este análisis es anterior a la foto de Syntage, así que no hay ratios por ejercicio de Rendafin. Abajo están los ratios que Syntage
      calculó en ese análisis.</span
    >
  </div>

  <div *ngSwitchCase="'no-verification'" class="snapshot-state snapshot-state--neutral" [class.snapshot-state--compact]="compact">
    <i class="fa-solid fa-id-card-clip" aria-hidden="true"></i>
    <span>Aún no hay análisis fiscal para este cliente.</span>
  </div>

  <div *ngSwitchCase="'forbidden'" class="snapshot-state snapshot-state--neutral" [class.snapshot-state--compact]="compact">
    <i class="fa-solid fa-user-lock" aria-hidden="true"></i>
    <span>No tienes permiso para ver esta sección. Si lo necesitas, pídelo a un administrador.</span>
  </div>

  <div *ngSwitchCase="'pinned'" class="snapshot-banner snapshot-banner--frozen" role="note">
    <i class="fa-solid fa-lock" aria-hidden="true"></i>
    <span>Esto es lo que se vio al aprobar el arrendamiento.</span>
  </div>
</ng-container>
